export default [
    { lat: 48.264043, lng: 16.209765 },
    { lat: 48.248042, lng: 16.239978 },
    { lat: 48.241640, lng: 16.237918 },
    { lat: 48.240725, lng: 16.255770 },
    { lat: 48.246670, lng: 16.258517 },
    { lat: 48.252157, lng: 16.269503 },
    { lat: 48.256271, lng: 16.263324 },
    { lat: 48.263128, lng: 16.292163 },
    { lat: 48.290091, lng: 16.347781 },
    { lat: 48.280953, lng: 16.369067 },
    { lat: 48.287806, lng: 16.369067 },
    { lat: 48.290091, lng: 16.378680 },
    { lat: 48.296943, lng: 16.375247 },
    { lat: 48.302425, lng: 16.381427 },
    { lat: 48.317495, lng: 16.382113 },
    { lat: 48.322518, lng: 16.393786 },
    { lat: 48.317039, lng: 16.401339 },
    { lat: 48.323888, lng: 16.419879 },
    { lat: 48.316185, lng: 16.438101 },
    { lat: 48.292257, lng: 16.440349 },
    { lat: 48.273621, lng: 16.480381 },
    { lat: 48.293760, lng: 16.480792 },
    { lat: 48.286810, lng: 16.516671 },
    { lat: 48.273813, lng: 16.508496 },
    { lat: 48.263232, lng: 16.545284 },
    { lat: 48.239946, lng: 16.553459 },
    { lat: 48.202424, lng: 16.536201 },
    { lat: 48.155181, lng: 16.574805 },
    { lat: 48.136595, lng: 16.575524 },
    { lat: 48.158428, lng: 16.514256 },
    { lat: 48.138877, lng: 16.433475 },
    { lat: 48.121920, lng: 16.434604 },
    { lat: 48.138123, lng: 16.326208 },
    { lat: 48.120790, lng: 16.312658 },
    { lat: 48.127196, lng: 16.223457 },
    { lat: 48.133602, lng: 16.237571 },
    { lat: 48.138500, lng: 16.234184 },
    { lat: 48.137370, lng: 16.220070 },
    { lat: 48.170890, lng: 16.186761 },
    { lat: 48.201755, lng: 16.208779 },
    { lat: 48.222447, lng: 16.199746 },
    { lat: 48.223951, lng: 16.187325 },
    { lat: 48.232977, lng: 16.198052 },
    { lat: 48.249521, lng: 16.198617 },
    { lat: 48.264043, lng: 16.209765 },
]
